import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const fallbackFirebaseConfig = {
  apiKey: "AIzaSyBhjpxlh65OFI-JCLQghtPag6LkaNg287g",
  authDomain: "the-engineer-aa768.firebaseapp.com",
  projectId: "the-engineer-aa768",
  storageBucket: "the-engineer-aa768.firebasestorage.app",
  messagingSenderId: "957490377112",
  appId: "1:957490377112:web:1f5627059c420139353bed",
};

const missingReactEnvKeys = [
  "REACT_APP_FIREBASE_API_KEY",
  "REACT_APP_FIREBASE_AUTH_DOMAIN",
  "REACT_APP_FIREBASE_PROJECT_ID",
  "REACT_APP_FIREBASE_STORAGE_BUCKET",
  "REACT_APP_FIREBASE_APP_ID",
  "REACT_APP_FIREBASE_FIRESTORE_DATABASE_ID",
].filter((key) => !process.env[key]);

if (missingReactEnvKeys.length) {
  console.warn(`[firebaseConfig] Missing React env keys: ${missingReactEnvKeys.join(", ")}. Falling back to bundled defaults.`);
}

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || fallbackFirebaseConfig.apiKey,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || fallbackFirebaseConfig.authDomain,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || fallbackFirebaseConfig.projectId,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || fallbackFirebaseConfig.storageBucket,
  messagingSenderId: fallbackFirebaseConfig.messagingSenderId,
  appId: process.env.REACT_APP_FIREBASE_APP_ID || fallbackFirebaseConfig.appId,
};

// 공개 화면과 관리자 화면이 같은 Firebase 앱 설정을 공유한다.
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const functions = getFunctions(app);
const storage = getStorage(app);
const firestoreDatabaseId = process.env.REACT_APP_FIREBASE_FIRESTORE_DATABASE_ID || "the-engineer-contents";
const db = getFirestore(app, firestoreDatabaseId);

// 로컬 에뮬레이터 연결이 필요할 때만 수동으로 켠다.
// connectFunctionsEmulator(functions, "localhost", 5001);

export default app;
export { auth, db, functions, storage };
